import { Component } from '@angular/core'
import { LeaseDetailService } from '@modules/private/lease/data/services/view/lease-detail.service'

@Component({
	selector: 'app-lease-release',
	templateUrl: './lease-release.component.html',
	styleUrls: ['./lease-release.component.scss']
})
export class LeaseReleaseComponent {
	constructor(
		public leaseDetailService: LeaseDetailService
	) {}

	get e() {
		return this.leaseDetailService.entityRelease
	}

	get photos(): string[] {
		return this.leaseDetailService.entityRelease.value.photos || []
	}

	get isDelivered(): boolean {
		return !!this.leaseDetailService.data?.assetDelivery?.date
	}

	get isLoading(): boolean {
		return !this.leaseDetailService.data
	}

	onFileSelected(fileUrl: string): void {
		this.leaseDetailService.entityRelease.patchValue({ fileRelease: fileUrl })
	}

	onFileDeleted(): void {
		this.leaseDetailService.entityRelease.patchValue({ fileRelease: '' })
	}

	onPhotosChanged(urls: string[]): void {
		this.leaseDetailService.entityRelease.patchValue({ photos: urls })
		this.leaseDetailService.saveRelease()
	}

	onDownloadPhoto(url: string): void {
		window.open(url, '_blank')
	}
}
